import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changeDateSeparatorFormatPipe',
})

export class ChangeDateSeparatorFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Remove microseconds if present
    const cleanValue = value.includes('.') ? value.split('.')[0] : value;
    const date = new Date(cleanValue);

    if (isNaN(date.getTime())) return '';

    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const isSameDate = (a: Date, b: Date) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

    if (isSameDate(date, today)) return 'Сегодня';
    if (isSameDate(date, tomorrow)) return 'Завтра';

    const months = ['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'];
    const days = ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'];

    return `${days[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]}`;
  }
}
